"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _qs = require('qs'); var _qs2 = _interopRequireDefault(_qs);
var _errors = require('shared/errors');









var _enum = require('./enum');
var _uuid = require('shared/services/uuid');
var _log = require('shared/log');
var _fetch = require('./fetch');

var _EventEmitter = require('shared/services/EventEmitter'); var _EventEmitter2 = _interopRequireDefault(_EventEmitter);
var _utils = require('./utils');
var _appState = require('shared/services/appState');

// Their timeout counts only time with the app in the foreground (mobile).
const FOREGROUND_TIMEOUT_COMMANDS = new Set(['StartUpload', 'StartPatientUpload'])

 class BloomClient extends _fetch.FetchCommands {
  
  
  
  
  

  
  
  
  
  
  

   __init() {this.connectionAttempt = 0}
   __init2() {this.unsentQueue = []}
   __init3() {this.sentQueue = []}
   __init4() {this.ws = null}
   __init5() {this.disposing = false}
  // From open() until close(): the app wants a socket, so reconnects run.
   __init6() {this.wantsConnection = false}
   __init7() {this.connectionTimeout = null}
  // The /csrf step of the attempt in flight, so that only one runs at a time
  // and a newer attempt can abandon it.
   __init8() {this.csrfRequest = null}
   __init9() {this.openTimeout = null}
   __init10() {this.disconnectTimeout = null}
   __init11() {this.pingTimeout = null}
  // The pings double as "this device is in use", so they run only while the
  // app wants them, across reconnects.
   __init12() {this.wantsPinging = true}

  
  
  
  __init13() {this.restFetchAlerts = _fetch.fetchAlerts}

  constructor (props) {
    super(_utils.makeRestBaseURL.call(void 0, props.connection), makeRestClientMetadata(props.connection));BloomClient.prototype.__init.call(this);BloomClient.prototype.__init2.call(this);BloomClient.prototype.__init3.call(this);BloomClient.prototype.__init4.call(this);BloomClient.prototype.__init5.call(this);BloomClient.prototype.__init6.call(this);BloomClient.prototype.__init7.call(this);BloomClient.prototype.__init8.call(this);BloomClient.prototype.__init9.call(this);BloomClient.prototype.__init10.call(this);BloomClient.prototype.__init11.call(this);BloomClient.prototype.__init12.call(this);BloomClient.prototype.__init13.call(this);BloomClient.prototype.__init14.call(this);BloomClient.prototype.__init15.call(this);BloomClient.prototype.__init16.call(this);BloomClient.prototype.__init17.call(this);BloomClient.prototype.__init18.call(this);BloomClient.prototype.__init19.call(this);BloomClient.prototype.__init20.call(this);BloomClient.prototype.__init21.call(this);BloomClient.prototype.__init22.call(this);BloomClient.prototype.__init23.call(this);BloomClient.prototype.__init24.call(this);BloomClient.prototype.__init25.call(this);BloomClient.prototype.__init26.call(this);BloomClient.prototype.__init27.call(this);BloomClient.prototype.__init28.call(this);BloomClient.prototype.__init29.call(this);BloomClient.prototype.__init30.call(this);BloomClient.prototype.__init31.call(this);BloomClient.prototype.__init32.call(this);BloomClient.prototype.__init33.call(this);BloomClient.prototype.__init34.call(this);BloomClient.prototype.__init35.call(this);BloomClient.prototype.__init36.call(this);BloomClient.prototype.__init37.call(this);BloomClient.prototype.__init38.call(this);BloomClient.prototype.__init39.call(this);BloomClient.prototype.__init40.call(this);BloomClient.prototype.__init41.call(this);BloomClient.prototype.__init42.call(this);BloomClient.prototype.__init43.call(this);BloomClient.prototype.__init44.call(this);BloomClient.prototype.__init45.call(this);BloomClient.prototype.__init46.call(this);BloomClient.prototype.__init47.call(this);
    const { host, port, secure, version, bundle } = props.connection
    const {
      DEFAULT_MSG_TIMEOUT_MS,
      CMD_RETRY_CONST_DELAY_MS,
      MAX_CMD_RETRIES,
      PING_INTERVAL_MS,
      PONG_TIMEOUT_MS,
      CONNECT_TIMEOUT_MS = 10000,
    } = props.config

    this.host = host
    this.port = port
    this.secure = secure
    this.version = version
    this.bundle = bundle

    this.DEFAULT_MSG_TIMEOUT_MS = DEFAULT_MSG_TIMEOUT_MS
    this.CMD_RETRY_CONST_DELAY_MS = CMD_RETRY_CONST_DELAY_MS
    this.MAX_CMD_RETRIES = MAX_CMD_RETRIES
    this.PING_INTERVAL_MS = PING_INTERVAL_MS
    this.PONG_TIMEOUT_MS = PONG_TIMEOUT_MS
    this.CONNECT_TIMEOUT_MS = CONNECT_TIMEOUT_MS

    this.connectionAttempt = 0 // Number of connection attempts before success
    this.unsentQueue = []
    this.sentQueue = []
    this.disposing = false

    const { on, off, emit } = new (0, _EventEmitter2.default)()
    this.on = on
    this.off = off
    this.emit = emit
  }

  __init14() {this.isConnected = () => _optionalChain([this, 'access', _13 => _13.ws, 'optionalAccess', _14 => _14.readyState]) === _enum.WS_STATE.OPEN}

  __init15() {this.open = (cfg = {}) => {
    // Note, client singleton may be stored in browser BFCache.
    // This can lead to messages getting resent even after a log out if queues
    // and other variables which are expected to be empty to not be.
    // Reset all queues on open to ensure BFCached local vars aren't reused.
    //
    // A live socket may still carry the PREVIOUS session's identity — the
    // signup auto-bridge logs the new user in without a logout first, so the
    // login-success open() used to hit fetchTokenAndOpen's ws-exists guard and
    // silently keep the stale user's connection (every subsequent command was
    // then rejected as unauthorized until a manual page reload). open() means
    // "(re)connect with THIS auth": dispose any existing socket first.
    // disposing=true keeps the teardown from scheduling an auto-reconnect
    // with the old credentials.
    if (this.ws) {
      this.disposing = true
      this.closeWS()
    }
    this.cancelAttempt()
    this.wantsConnection = true
    this.connectionAttempt = 0
    this.unsentQueue = []
    this.sentQueue = []
    // A new session starts in use, as the app's activity state does.
    this.wantsPinging = true

    this.disposing = false
    this.fetchTokenAndOpen(cfg)
  }}

  __init16() {this.close = () => {
    this.disposing = true
    this.wantsConnection = false
    this.cancelAttempt()
    this.closeWS()
  }}

  // Starts a reconnect attempt at once unless the socket is open, for a return
  // to the foreground or a network that came back. An attempt in flight may be
  // stuck on the old network path, so it is abandoned, and the backoff starts
  // over.
  __init17() {this.reconnectNow = () => {
    if (!this.wantsConnection || this.isConnected()) return

    _log.log.info('Reconnecting now')
    this.detachWS()
    this.clearPingTimers()
    this.cancelAttempt()
    this.connectionAttempt = 0
    this.fetchTokenAndOpen({})
  }}

  // After a network change an open socket can still be bound to the old path,
  // where it looks open but nothing arrives. Ping it now instead of at the next
  // interval; a socket that is not open reconnects at once.
  __init18() {this.checkConnection = () => {
    if (!this.isConnected()) return this.reconnectNow()
    // A ping is already waiting for its pong, or the device is away and a ping
    // would say it is in use.
    if (this.disconnectTimeout || !this.wantsPinging) return

    this.clearPingTimers()
    this.runPing()
  }}

   __init19() {this.detachWS = () => {
    if (!this.ws) return

    // Ensure ws can be garbage collected https://www.w3.org/TR/websockets/#garbage-collection
    this.ws.onopen = null
    this.ws.onmessage = null
    this.ws.onclose = null
    this.ws.onerror = null
    this.ws.close()
    this.ws = null
  }}

   __init20() {this.closeWS = () => {
    this.detachWS()
    this.clearPingTimers()
    this.handleWSClose()
  }}

   __init21() {this.makeMsgOut = (
    Command,
    Data = {},
  ) => ({ Command, Data, Echo: _uuid.uuidv4.call(void 0, ) })}

   __init22() {this.handleSend = (
    Command,
    Data,
    ttl = this.DEFAULT_MSG_TIMEOUT_MS,
    attempt = 0,
  ) => {
    const body = this.makeMsgOut(Command, Data)
    const timeoutMsg = {
      Command: body.Command,
      Echo: body.Echo,
      Status: 'timeout',
      Data: {},
    }

    return new Promise((resolve, reject) => {
      const expire = () => this.processWSMessage(timeoutMsg)
      // Suspended with an upload's start unanswered, the app finds the answer
      // waiting on return; a wall-clock timeout would fail the send instead.
      // Starting again isn't safe: a part's upload would get a second session.
      let stopTimeout
      if (FOREGROUND_TIMEOUT_COMMANDS.has(Command)) stopTimeout = _appState.foregroundTimeout.call(void 0, ttl, expire)
      else {
        const timeout = setTimeout(expire, ttl)
        stopTimeout = () => clearTimeout(timeout)
      }

      


      const callback = (err, res, attempt = 0) => {
        stopTimeout()

        if (_optionalChain([err, 'optionalAccess', _15 => _15.Status]) !== 'service_unavailable' || attempt > this.MAX_CMD_RETRIES) {
          err ? reject(err) : resolve(res)
          return
        }

        const delay = this.CMD_RETRY_CONST_DELAY_MS + _utils.makeExponentialDelay.call(void 0, attempt)

        _log.log.info(
          `${Command} failed: service unavailable.\n` +
          `Scheduling a retry (${attempt}/${this.MAX_CMD_RETRIES}) ` +
          `in ~${Math.round(delay / 1000)}s...`,
        )

        return setTimeout(
          () => this.handleSend(Command, Data, ttl, attempt)
            .then(resolve)
            .catch(reject),
          delay,
        )
      }

      this.queueSend(body, callback, attempt)
    })
  }}

  __init23() {this.send = (
    Command,
    Data,
    ttl,
  ) => this.handleSend(Command, Data, ttl)}

  // Pings right away, so the server hears the user is back without waiting a
  // whole interval.
  __init24() {this.startPinging = () => {
    if (this.wantsPinging) return
    this.wantsPinging = true
    this.runPing()
  }}

  __init25() {this.stopPinging = () => {
    this.wantsPinging = false
    this.clearPingTimers()
  }}

   __init26() {this.schedulePing = () => {
    this.pingTimeout = setTimeout(this.runPing, this.PING_INTERVAL_MS)
  }}

   __init27() {this.clearPingTimers = () => {
    if (this.pingTimeout) clearTimeout(this.pingTimeout)
    if (this.disconnectTimeout) clearTimeout(this.disconnectTimeout)
    this.pingTimeout = null
    this.disconnectTimeout = null
  }}

   __init28() {this.runPing = () => {
    if (_optionalChain([this, 'access', _16 => _16.ws, 'optionalAccess', _17 => _17.readyState]) !== _enum.WS_STATE.OPEN) return

    const body = this.makeMsgOut(_enum.ServiceCommand.PING, {})
    this.ws.send(JSON.stringify(body))
    this.disconnectTimeout = setTimeout(this.closeWS, this.PONG_TIMEOUT_MS)
  }}

   __init29() {this.handlePong = () => {
    this.clearPingTimers()
    if (this.wantsPinging) this.schedulePing()
  }}

   __init30() {this.delayedOpenSocket = (cfg = {}) => {
    if (this.connectionTimeout || this.ws) return

    const delayMs = _utils.makeReconnectDelay.call(void 0, this.connectionAttempt)
    this.connectionTimeout =
      setTimeout(() => this.fetchTokenAndOpen(cfg), delayMs)
  }}

   __init31() {this.clearConnectTimeouts = () => {
    if (this.connectionTimeout) clearTimeout(this.connectionTimeout)
    this.connectionTimeout = null
  }}

  // Drops the attempt in flight or waiting in backoff, without a retry.
   __init32() {this.cancelAttempt = () => {
    this.clearConnectTimeouts()
    _optionalChain([this, 'access', _18 => _18.csrfRequest, 'optionalAccess', _19 => _19.abort, 'call', _20 => _20()])
    this.csrfRequest = null
    if (this.openTimeout) clearTimeout(this.openTimeout)
    this.openTimeout = null
  }}

   __init33() {this.fetchTokenAndOpen = (cfg) => {
    // We just triggered, so let's clear out the timer
    this.clearConnectTimeouts()

    if (!this.wantsConnection) return
    if (this.ws) return _log.log.info("`fetchTokenAndOpen()` but ws already exists!")
    if (this.csrfRequest) return _log.log.info("`fetchTokenAndOpen()` but /csrf is in flight!")
    this.connectionAttempt += 1

    if (cfg.token || cfg.auth) return this.openWithToken(cfg)

    // React Native gives fetch no timeout, so a /csrf sent down a dead network
    // path would never settle and no other attempt would start.
    const request = new AbortController()
    this.csrfRequest = request
    const timeout = setTimeout(() => request.abort(), this.CONNECT_TIMEOUT_MS)

    this.csrf(request.signal)
      .then(r => {
        if (this.csrfRequest !== request) return
        this.csrfRequest = null
        this.openWithToken({ token: r.CSRF })
      })
      .catch(e => {
        // Abandoned for a newer attempt, or the client was closed
        if (this.csrfRequest !== request) return
        this.csrfRequest = null

        if (e instanceof _errors.RestError && e.response.ServerError === false) {
          // Login session timed out or something else changed
          this.emit(_enum.ClientEvent.SESSION_EXPIRED)
        } else {
          // Sever error, try again
          _log.log.info('Unexpected failure getting CSRF, possibly offline')
          this.delayedOpenSocket()
        }
      })
      .finally(() => clearTimeout(timeout))
  }}

   __init34() {this.openWithToken = ({ token: csrftoken, auth }) => {
    if (this.ws) return _log.log.info("`openWithToken()` but ws already exists!")

    try {
      const { secure, host, port, version, bundle } = this
      const protocol = secure ? 'wss' : 'ws'
      const endpoint = auth ? 'ws2' : 'ws'
      const queryPayload = auth ? { version, bundle } : { csrftoken, version, bundle }
      const query = _qs2.default.stringify(queryPayload)
      const url = `${protocol}://${host}:${port}/${endpoint}?${query}`
      const authProtocol = auth ? _utils.buildAuthProtocol.call(void 0, auth) : undefined

      this.ws = new WebSocket(url, authProtocol)
      this.ws.onopen = this.handleWSOpen.bind(this)
      this.ws.onmessage = this.handleWSMessage.bind(this)
      this.ws.onclose = this.handleWSClose.bind(this)
      this.openTimeout = setTimeout(this.handleOpenTimeout, this.CONNECT_TIMEOUT_MS)
    } catch (err) {
      // Failure starting up websocket, restart attempt to connect
      _log.log.error(err )

      // Null out ws in case it broke before onclose bound
      this.ws = null
      this.delayedOpenSocket()
    }
  }}

  // A WebSocket opening over a dead path may not settle either.
   __init35() {this.handleOpenTimeout = () => {
    this.openTimeout = null
    if (_optionalChain([this, 'access', _21 => _21.ws, 'optionalAccess', _22 => _22.readyState]) !== _enum.WS_STATE.CONNECTING) return

    _log.log.info('WebSocket open timed out')
    this.closeWS()
  }}

   __init36() {this.handleWSOpen = () => {
    if (this.openTimeout) clearTimeout(this.openTimeout)
    this.openTimeout = null
    this.connectionAttempt = 0
    this.emit(_enum.ClientEvent.OPEN)

    // The server counts a new connection as activity, so a device that is
    // away says so again.
    if (this.wantsPinging) this.schedulePing()
    else this.send('ClientInactive', {}).catch(() => null)
    this.processQueue()
  }}

  // The attempt count is reset only by an open, so a socket that fails to open
  // backs off instead of retrying at once.
   __init37() {this.handleWSClose = () => {
    this.ws = null
    if (this.openTimeout) clearTimeout(this.openTimeout)
    this.openTimeout = null

    // Queue sent but not confirmed messages to be re-sent
    let item
    while ((item = this.sentQueue.shift())) {
      const [msg, callback, attempt] = item
      this.unsentQueue.unshift([msg, callback, attempt])
    }

    if (!this.disposing) {
      this.emit(_enum.ClientEvent.UNEXPECTED_CLOSED)
      this.delayedOpenSocket()
    } else this.emit(_enum.ClientEvent.CLOSED)
  }}

   __init38() {this.processWSMessage = (msg) => {
    const sentIdx = this.sentQueue.findIndex(i => i[0].Echo === msg.Echo)
    if (sentIdx > -1) {
      const [item] = this.sentQueue.splice(sentIdx, 1)
      const [, callback, attempt] = item

      if (msg.Status === 'success') callback(null, msg.Data, attempt)
      else callback({ ...msg.Data , Status: msg.Status }, null, attempt)

      this.processQueue()
    }
  }}

   __init39() {this.handleWSMessage = (event) => {
    let msg
    try {
      msg = JSON.parse(event.data) 
    } catch (e) {
      _log.log.info('Discarding a malformed event', e)
      return
    }

    switch (msg.Command) {
      case _enum.ServiceCommand.PING: return this.handlePong()
      case _enum.ServiceCommand.AUTH_ERROR: return this.emit(_enum.ClientEvent.AUTH_ERROR, msg.Data)
      case _enum.ServiceCommand.AUTH_SUCCESS: return this.emit(_enum.ClientEvent.AUTH_SUCCESS, msg.Data)
    }
    if (!msg.Echo) return this.emit(_enum.ClientEvent.INBOUND, msg)

    this.processWSMessage(msg)
  }}

   __init40() {this.queueSend = (body, callback, attempt = 0) => {
    // Queue message if present, then empty queue in order if connection is ready
    if (body) this.unsentQueue.push([body, callback, attempt])

    this.processQueue()
  }}

   __init41() {this.processQueue = () => {
    if (_optionalChain([this, 'access', _23 => _23.ws, 'optionalAccess', _24 => _24.readyState]) !== _enum.WS_STATE.OPEN) return

    let item
    while ((item = this.unsentQueue.shift())) {
      if (!item[2]) item[2] = 0
      item[2] = item[2] + 1

      const [msg] = item

      this.sentQueue.push(item)
      this.ws.send(JSON.stringify(msg))
    }
  }}

  // A command queued while the socket is down waits for the reconnect and its
  // timeout does not apply until it is sent, so the CSRF step of an upload
  // could otherwise wait forever with nothing sent (the owner's never-ending
  // video send). Bound it here, for uploads only; other commands keep their
  // wait-for-reconnect behaviour.
   __init42() {this.getUploadCsrf = () => new Promise((resolve, reject) => {
    const timeout = setTimeout(
      () => reject(new Error('GetCsrfToken for upload timed out')),
      this.DEFAULT_MSG_TIMEOUT_MS * 2,
    )
    this.send('GetCsrfToken')
      .then(resolve, reject)
      .finally(() => clearTimeout(timeout))
  })}

  __init43() {this.uploadFile = (file, signal) =>
    this.getUploadCsrf()
      .then(r => this.uploadFileWithCSRF(r.Token, file, signal))}

  __init44() {this.uploadAvatar = (file, signal) =>
    this.getUploadCsrf()
      .then(r => this.uploadAvatarWithCSRF(r.Token, file, signal))}

  __init45() {this.uploadOrgLogo = (orgKey, kind, file, signal) =>
    this.getUploadCsrf()
      .then(r => this.uploadOrgLogoWithCSRF(r.Token, orgKey, kind, file, signal))}

  __init46() {this.uploadPatientPhoto = (file, signal) =>
    this.getUploadCsrf()
      .then(r => this.uploadPatientPhotoWithCSRF(r.Token, file, signal))}

  __init47() {this.superImpersonate = (userKey) =>
    this.send('GetCsrfToken')
      .then(r => this.superImpersonateWithCSRF(r.Token, userKey))}
} exports.default = BloomClient;

const LOGIN_SMS_MFA_CAPABILITY = 'login_sms_mfa'
const MOBILE_BUNDLE = 'com.bloomapi.bloomtext'

const makeRestClientMetadata = ({ version, bundle }) => ({
  client_platform: bundle === 'web'
    ? 'web'
    : bundle === MOBILE_BUNDLE ? 'mobile' : 'unknown',
  client_bundle: bundle || 'unknown_client_bundle',
  client_version: version || 'unknown_client_version',
  client_capabilities: LOGIN_SMS_MFA_CAPABILITY,
})
